//Navigations
var openMenus = document.querySelectorAll(".open-menu");
var container = document.querySelector(".content");
var body = document.body;
function scrollControl() {
  if (container.classList.contains("menu-open")) {
    var scrollY = document.documentElement.style.getPropertyValue("--scroll-y");
    body.style.position = "fixed";
    body.style.width = "99%";
    body.style.right = "1%";
    body.style.top = "-".concat(scrollY);
  } else {
    var scrollY = body.style.top;
    body.style.position = "";
    body.style.width = "";
    body.style.right = "";
    body.style.top = "";
    window.scrollTo(0, parseInt(scrollY || "0") * -1);
  }
  window.addEventListener("scroll", function () {
    document.documentElement.style.setProperty(
      "--scroll-y",
      "".concat(window.scrollY, "px")
    );
  });
}

for (let i = 0; i < openMenus.length; i++) {
  const currentOpen = openMenus[i];
  const nextNode = currentOpen.nextElementSibling;
  var mobileWidth = "100%";
  var desktopWidth = "50%";
  function setWidth() {
    if (window.matchMedia("(min-width:1024px)").matches) {
      return desktopWidth;
    } else {
      return mobileWidth;
    }
  }
  function resizeWidth() {
    window.addEventListener("resize", function () {
      if (
        nextNode.classList.contains("open") &&
        window.matchMedia("(min-width:1025px)").matches
      ) {
        nextNode.style.width = "50%";
      } else if (
        nextNode.classList.contains("open") &&
        window.matchMedia("(max-width:1024px)").matches
      ) {
        nextNode.style.width = "100%";
      } else {
        nextNode.style.width = "0";
      }
    });
  }

  const tween = gsap.to(nextNode, {
    duration: 0.6,
    width: setWidth(),
    paused: true,
    reversed: true,
    ease: "power4.in",
    onStart: () => {
      currentOpen.setAttribute('aria-expanded', 'true');
      nextNode.classList.remove("closed");
      currentOpen.setAttribute('aria-busy', 'true');
    },
    onComplete: () => {
      const parentClass = currentOpen.parentElement.getAttribute('class');
      const currentClass = currentOpen.getAttribute('class');

      if (currentClass.includes('active')) {
        HAHAccessibility.trapFocus({
          container: `.${parentClass}`,
          closeElement: '.open-menu.active',
          firstElementToFocus: '.ADA_firstElement',
          unbindEvents: true,
        });
      }

      currentOpen.setAttribute('aria-busy', 'false');
      currentOpen.setAttribute('aria-label', 'Close Menu');
      currentOpen.removeAttribute('aria-haspopup');
      currentOpen.removeAttribute('aria-expanded');
      $('.open-menu.active').one('click', () => {
        currentOpen.setAttribute('aria-busy', 'true');
      });
    },
    onReverseComplete: () => {
      currentOpen.setAttribute('aria-busy', 'false');
      nextNode.classList.add("closed");
      const parentClass = currentOpen.parentElement.getAttribute('class');
      currentOpen.setAttribute('aria-expanded', 'false');
      currentOpen.setAttribute('aria-haspopup', 'dialog');
      if(parentClass === "search") {
        currentOpen.setAttribute('aria-label', 'Search Menu');
      } else if(parentClass === "global-sites") {
        currentOpen.setAttribute('aria-label', 'Languages Menu');
      } else if(parentClass === "hdr-account") {
        currentOpen.removeAttribute('aria-label');
      }
    },
  });

  // For all currentOpen items, except Bonvoy Points Login
  gsap.registerPlugin("timeScale");
  if (currentOpen.id !== "btn_login_points") {
    const children = nextNode.querySelectorAll('[data-animate="true"]');
    const childTween = gsap.timeline();
    gsap.set(children, {
      opacity: 0,
      x: 180,
    });
    function open() {
      childTween.timeScale(1);
      childTween.to(children, {
        opacity: 1,
        x: 0,
        duration: 0.5,
        delay: 0.6,
        stagger: 0.025,
        ease: "power1.out",
        overwrite: "auto",
      });
    }
    function close() {
      childTween.timeScale(99);
      childTween.to(children, {
        opacity: 0,
        x: 180,
        duration: 0.2,
        ease: "power1.out",
        overwrite: "auto",
      });
    }
    currentOpen.addEventListener("click", function (event) {
      currentOpen.classList.toggle("active");
      nextNode.classList.toggle("open");
      container.classList.toggle("menu-open");
      tween.reversed() ? tween.play() : tween.reverse();
      tween.reversed() ? close() : open();
      scrollControl();
      resizeWidth();
    });
  }
}
